const types = [
    {'value': 'normal', 'label': 'normal'},
    {'value': 'regex', 'label': 'regex'}
]

export default types
